import { render, staticRenderFns } from "./protocolandrules.vue?vue&type=template&id=1779a044&scoped=true&"
import script from "./protocolandrules.vue?vue&type=script&lang=js&"
export * from "./protocolandrules.vue?vue&type=script&lang=js&"
import style0 from "./protocolandrules.vue?vue&type=style&index=0&id=1779a044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1779a044",
  null
  
)

export default component.exports